export const useEmptyTrash = (): {
  emptied: boolean
  emptyTrash: () => Promise<void>
} => {
  return { emptyTrash: async () => console.error('not implemented'), emptied: false }
}
